export default __webpack_public_path__ + "static/svg-icons-b7af2423446737d4dc976e57b56bafa3.svg";